/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum TokenPolicyAction {
  ResetPassword = "ResetPassword",
  ConfirmAvailability = "ConfirmAvailability",
  NoPasswordLogin = "NoPasswordLogin",
  ViewBioNoPasswordLogin = "ViewBioNoPasswordLogin",
  ViewBenchNoPasswordLogin = "ViewBenchNoPasswordLogin",
  BenchUrlNoPasswordLogin = "BenchUrlNoPasswordLogin",
}

export const TokenPolicyActionDisplay: Record<TokenPolicyAction, string> = {
  [TokenPolicyAction.ResetPassword]: "Reset Password",
  [TokenPolicyAction.ConfirmAvailability]: "Confirm Availability",
  [TokenPolicyAction.NoPasswordLogin]: "No Password Login",
  [TokenPolicyAction.ViewBioNoPasswordLogin]: "View Bio No Password Login",
  [TokenPolicyAction.ViewBenchNoPasswordLogin]: "View Bench No Password Login",
  [TokenPolicyAction.BenchUrlNoPasswordLogin]: "Bench Url No Password Login",
};
